import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import { useUploadDocumentContext } from '../UploadDocumentModal/context';

import Folder from './Folder';

import styles from './FolderStructure.module.scss';

function findFolderPath(folderData, targetFolder, path = []) {
  if (!targetFolder) return null;

  if (folderData.location_id === targetFolder)
    return [...path, folderData.location_id];

  for (let child of folderData.children_folders || []) {
    const result = findFolderPath(child, targetFolder, [
      ...path,
      folderData.location_id,
    ]);
    if (result) return result;
  }

  return null;
}

const FolderStructure = ({ id, input, folderData, onChange }) => {
  const { formData } = useUploadDocumentContext();
  const initialSelectedFolder =
    formData?.destination?.location_id || folderData.location_id;
  const [selectedFolder, setSelectedFolder] = useState(initialSelectedFolder);

  const initialExpandedFolders = useMemo(() => {
    return findFolderPath(folderData, initialSelectedFolder) || [];
  }, [folderData, initialSelectedFolder]);

  const handleChange = (val) => {
    setSelectedFolder(val.location_id);

    if (onChange) {
      onChange(val);
    }
  };

  return (
    <div className={styles.folderStructureContainer}>
      <Folder
        {...input}
        id={id}
        folderData={folderData}
        isRoot
        selectedFolder={selectedFolder}
        setSelectedFolder={(option) => handleChange(option)}
        expandedFolders={initialExpandedFolders}
      />
    </div>
  );
};

FolderStructure.propTypes = {
  folderData: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  input: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  defaultValue: PropTypes.object,
};

export default FolderStructure;
